"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _thirdSam = _interopRequireDefault(require("@/api/activity/thirdSam.js"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'expandList',
  components: {},
  props: {
    actId: {
      type: Number,
      default: ''
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newVal) {
        console.log('actId', newVal);
        // 有actId时选中，无actId时不选
        // this.searchForm.activityId = newVal && newVal != 'null' ? newVal : '';
        // this.searchForm2.activityId = newVal && newVal != 'null' ? newVal : '';
        // this.searchForm.page = 1;
        // this.fetchList(newVal);
      }
    }
  },
  data: function data() {
    return {
      shoplist: [],
      loading: false,
      searchForm: {
        couponName: '',
        verifyStatus: '',
        orderNo: '',
        status: '',
        thirdPartyNo: '',
        couponId: '',
        productName: '',
        timeRange: [],
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      couponList: [],
      showUserDialog: false,
      // 控制弹窗显示
      exchangeCode: [],
      searchForm2: {
        activityId: '',
        status: '',
        exchangeCode: '',
        storeId: '',
        verifyStatus: '',
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      },
      downloadLoading: false,
      showCouponLogDialog: false,
      submitLoading: false,
      couponLogForm: {
        couponLogId: '',
        couponNo: '',
        originalCouponNo: ''
      }
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    dateFormat2: function dateFormat2(date, format) {
      var d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return '';
      var map = {
        'yyyy': d.getFullYear(),
        'MM': ('0' + (d.getMonth() + 1)).slice(-2),
        'dd': ('0' + d.getDate()).slice(-2),
        'HH': ('0' + d.getHours()).slice(-2),
        'mm': ('0' + d.getMinutes()).slice(-2),
        'ss': ('0' + d.getSeconds()).slice(-2)
      };
      var fmt = format || 'yyyy-MM-dd HH:mm:ss';
      Object.keys(map).forEach(function (k) {
        fmt = fmt.replace(k, map[k]);
      });
      return fmt;
    },
    download: function download() {
      var _this = this;
      this.downloadLoading = true;
      var params = {
        couponName: this.searchForm.couponName,
        verifyStatus: this.searchForm.verifyStatus,
        orderNo: this.searchForm.orderNo,
        status: this.searchForm.status,
        thirdPartyNo: this.searchForm.thirdPartyNo,
        couponId: this.searchForm.couponId,
        productName: this.searchForm.productName
      };
      if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
        params.startTime = this.searchForm.timeRange[0];
        params.endTime = this.searchForm.timeRange[1].replace('00:00:00', '23:59:59');
      }
      _thirdSam.default.exportCouponList(params).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '优惠券列表.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this.downloadLoading = false;
      });
    },
    changeTime: function changeTime(e) {
      console.log(e);
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      var params = _objectSpread({}, this.searchForm);
      if (params.timeRange && params.timeRange.length === 2) {
        params.startTime = params.timeRange[0];
        params.endTime = params.timeRange[1].replace('00:00:00', '23:59:59');
      }
      delete params.timeRange;
      _thirdSam.default.getCouponList(params).then(function (res) {
        // res.records.forEach(item => {
        //     if (item.exchangeTime) {
        //         item.exchangeTimeFmt = this.dateFormat2(item.exchangeTime);
        //     }
        // });

        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        expandId: '',
        page: 1,
        limit: 10,
        total: 0,
        mobile: '',
        cardNo: ''
      }, this.fetchList();
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange2: function handlePageChange2(newPage) {
      this.searchForm.page2 = newPage;
      this.getUserList();
    },
    handleSizeChange2: function handleSizeChange2(newSize) {
      this.searchForm2.limit = newSize;
      this.searchForm2.page = 1;
      this.getUserList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    handleDetail: function handleDetail(row) {
      this.searchForm2.status = '';
      this.searchForm2.page = 1;
      this.searchForm2.exchangeCode = row.exchangeCode;
      this.searchForm2.mobile = row.mobile;
      this.searchForm2.cardNo = row.cardNo;
      this.getUserList();
      this.showUserDialog = true;
    },
    getUserList: function getUserList() {
      // couponApi.getCouponList(this.searchForm2).then(res => {
      //     this.couponList = res.records || []
      //     this.searchForm2.total = res.total || 0

      // })
    },
    openCouponLogDialog: function openCouponLogDialog(row) {
      this.couponLogForm.couponLogId = row.couponLogId;
      this.couponLogForm.couponNo = '';
      this.couponLogForm.originalCouponNo = row.couponNo;
      this.showCouponLogDialog = true;
    },
    submitCouponLog: function submitCouponLog() {
      var _this3 = this;
      if (!this.couponLogForm.couponNo) {
        this.$message.warning('请输入券码');
        return;
      }
      this.submitLoading = true;
      _thirdSam.default.updateCouponLogNo({
        couponLogId: this.couponLogForm.couponLogId,
        couponNo: this.couponLogForm.couponNo
      }).then(function (res) {
        _this3.$message.success('修改成功');
        _this3.showCouponLogDialog = false;
        _this3.fetchList();
      }).finally(function () {
        _this3.submitLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetchList();
  }
};